import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTranslate$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTranslate extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8c3db84b0d9026c9d89d685fffaf043c5c87aa23', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6acbb98118f47ca78f17453c69c1e327463ff560', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c1804d47e4f330f097084dad1698e75970bca678', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.75 2.5h-1.5V4H4v1.5h1.146A8.7 8.7 0 0 0 6.86 8.114a9.4 9.4 0 0 1-2.139 1.19l.558 1.392A10.8 10.8 0 0 0 8.013 9.12c.882.646 1.879 1.145 2.959 1.577l.556-1.392c-.894-.358-1.693-.751-2.394-1.229A10.6 10.6 0 0 0 10.876 5.5H12V4H8.75zm-.77 4.614q.676-.72 1.199-1.614h-2.37c.33.622.72 1.152 1.17 1.614m7.688 9.386L16.2 18h1.6l-2.123-5.934c-.395-1.106-1.959-1.106-2.354 0L11.2 18h1.6l.532-1.5zm-.357-1-.81-2.27-.812 2.27zM16 9V7a1 1 0 0 0-1-1h-2v1h2v2zM6 13v2a1 1 0 0 0 1 1h2v-1H7v-2z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-translate", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-translate"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-translate":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTranslate$1);
            }
            break;
    } });
}

const CosmosIconTranslate = CosmosIconTranslate$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTranslate, defineCustomElement };
